import './ModalPortal.scss';
import React from 'react'
import ReactDOM from 'react-dom';
import { useSearchParams } from 'react-router-dom';
import Translate from 'components/common/Translate';
import CoreComponent from "../../utilities/component-utilities/CoreComponent";

const APP_DIALOG_ID = 'app-dialog';

type ModalPortalProps = {
    name: string,
    title: string | React.ReactNode,
    onClose?: () => void;
    disableCloseOnOutsideClick?: boolean,
    children: React.ReactNode | React.ReactNode[],
}

type ModalPortalClassProps = ModalPortalProps &  {
    isOpen: boolean,
}

class ModalPortalClass extends CoreComponent<ModalPortalClassProps> {
    componentDidMount() {
        super.componentDidMount();
        document.addEventListener('keydown', this.onKeyPress);
        this.setModalOpenAttribute();
    }

    componentDidUpdate(prevProps: Readonly<ModalPortalClassProps>, prevState: Readonly<{}>, snapshot?: any): void {
        super.componentDidUpdate(prevProps, prevState, snapshot);
        this.setModalOpenAttribute();
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        this.setModalOpenAttribute(false);
        document.removeEventListener('keydown', this.onKeyPress);
    }

    private setModalOpenAttribute = (open?: boolean) => {
        const isOpen = open === false ? false : true;
        const dialog = document.getElementById('app-dialog') as HTMLDialogElement;
        dialog.open = isOpen;
    }

    // #region background
    private backgroundClick = () => {
        this.closeModal();
    };

    private onKeyPress = (e: KeyboardEvent) => {
        if (e.key === 'Escape') {
            e.preventDefault();
            e.stopPropagation();
            this.closeModal();
        }
    };

    private closeModal = () => {
        if (!this.props.disableCloseOnOutsideClick) {
            this.setModalOpenAttribute(false); 
            this.context.navigate(-1);
        }
    };
    // #endregion background

    renderModal = () => {
        if (this.props.isOpen) {
            const title = typeof this.props.title == 'string' ? <Translate i18nKey={this.props.title} /> : this.props.title;
            return <>
                <div onClick={this.backgroundClick} className="background">
                </div>
                <div className="body theme-bg">
                    <div className="header">
                        {title}
                    </div>
                    <div className="content">
                        {this.props.children}
                    </div>
                </div>
            </>;
        } else return <></>;
    };

    render() {
        return ReactDOM.createPortal(
            <>
                {this.renderModal()}
            </>,
            document.getElementById(APP_DIALOG_ID)!
        );
    }
}

const ModalPortal = (props: ModalPortalProps) => {
    const [searchParams ] = useSearchParams();

    return searchParams.has(props.name) ? 
        <ModalPortalClass {...props} isOpen={searchParams.has(props.name)} /> 
        : <></>;
}


export default ModalPortal;
